module.exports = __webpack_public_path__ + "img/icon_pdf.8b17f5bf.png";